/**
 * NumericStepper
 */
export class NumericStepper {
  /**
  * @param {HTMLElement} elem
  */
  constructor(elem) {
    // Dom elements
    this._elem = elem;
    this._input = elem.querySelector('[type="number"]');
    this._btnDown = elem.querySelector('[data-role="down"]');
    this._btnUp = elem.querySelector('[data-role="up"]');
    this._input = elem.querySelector('[type="number"]');

    // Set options
    this._options = {
      min: Number.NEGATIVE_INFINITY,
      max: Number.POSITIVE_INFINITY,
      step: 1,
    };

    Object.keys(this._options).forEach( (option) => {
      if (this._input.hasAttribute(option)) {
        this._options[option] = parseFloat(this._input.getAttribute(option), 10);
      }
    });

    this._init();
  }

  /**
   * @private
   */
  _init() {
    const parsed = parseFloat(this._input.value, 10);
    this._default = isNaN(parsed) ? (this._options.min != Number.NEGATIVE_INFINITY ? this._options.min : 0 ) : parsed;
    this._value = this._default;
    this._setValue();

    // Down
    this._btnDown.addEventListener('click', (e) => {
      const substract = this._value - this._options.step;

      if (substract >= this._options.min) {
        this._value = substract;
        this._setValue();
      }
    });

    // Up
    this._btnUp.addEventListener('click', (e) => {
      const add = this._value + this._options.step;

      if (add <= this._options.max) {
        this._value = add;
        this._setValue();
      };
    });

    // Input
    this._input.addEventListener('blur', (e) => {
      const value = parseFloat(this._input.value, 10);

      if (isNaN(value)) {
        this._value = this._default;
      } else if (value < this._options.min) {
        this._value = this._options.min;
      } else if (value > this._options.max) {
        this._value = this._options.max;
      } else {
        this._value = value;
      }

      this._setValue();
    });
  }

  /**
   * @private
   */
  _setValue() {
    this._input.value = this._value;
    this._btnDown.disabled = this._value === this._options.min;
    this._btnUp.disabled = this._value === this._options.max;
  }
}
